(() => {
  const SCOPE_SELECTORS = [
    '.section-resource-list',
    '.main-collection-grid',
    '.product-grid',
    '.resource-list'
  ];

  function inScope(el) {
    return SCOPE_SELECTORS.some((s) => el.closest(s));
  }

  function moveBrand(cardContent) {
    if (!inScope(cardContent)) return;

    const brand = cardContent.querySelector(':scope > .inura-card-brand');
    if (!brand) return;

    const title =
      cardContent.querySelector('product-title') ||
      cardContent.querySelector('.product-title') ||
      cardContent.querySelector('.view-product-title') ||
      cardContent.querySelector('.title-text') ||
      null;

    if (!title) return;

    const titleContainer =
      title.closest('product-title, .product-title, .view-product-title') || title;

    titleContainer.parentNode?.insertBefore(brand, titleContainer);
  }

  function processNode(node) {
    if (!(node instanceof Element)) return;

    if (node.matches('.product-card__content')) moveBrand(node);
    node.querySelectorAll('.product-card__content').forEach(moveBrand);
  }

  function init() {
    document.querySelectorAll('.product-card__content').forEach(moveBrand);

    const root = document.body || document.documentElement;
    if (!root) return;

    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          processNode(node);
        }
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* INURA — retour contextuel vers la LP SKIN1004 */
(() => {
  const campaignSource = 'skin1004-lp';
  const campaignReturnUrlKey = 'inura:skin1004:return-url';
  const campaignActiveKey = 'inura:skin1004:active';

  let mountQueued = false;

  function safeStorageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in privacy-restricted contexts.
    }
  }

  function isProductPage() {
    return window.location.pathname.indexOf('/products/') === 0;
  }

  const initialUrl = new URL(window.location.href);
  const startsFromCampaign =
    initialUrl.searchParams.get('source') === campaignSource;

  const isCampaignLanding =
    window.location.pathname === '/pages/skin1004';

  if (startsFromCampaign) {
    safeStorageSet(campaignActiveKey, '1');
  }

  /*
   * Ne surveiller les changements de page que lorsque le parcours
   * SKIN1004 est réellement concerné.
   */
  const shouldWatch =
    isCampaignLanding ||
    (
      isProductPage() &&
      (
        startsFromCampaign ||
        safeStorageGet(campaignActiveKey) === '1'
      )
    );

  if (!shouldWatch) return;

  function campaignIsActive() {
    if (!isProductPage()) return false;

    const currentUrl = new URL(window.location.href);

    const comesFromCampaign =
      currentUrl.searchParams.get('source') === campaignSource;

    if (comesFromCampaign) {
      safeStorageSet(campaignActiveKey, '1');
    }

    return (
      comesFromCampaign ||
      safeStorageGet(campaignActiveKey) === '1'
    );
  }

  function buildReturnUrl() {
    const storedReturnUrl =
      safeStorageGet(campaignReturnUrlKey) ||
      '/pages/skin1004';

    try {
      const url = new URL(
        storedReturnUrl,
        window.location.origin
      );

      if (url.origin !== window.location.origin) {
        return '/pages/skin1004?inura_return=1';
      }

      url.searchParams.set('inura_return', '1');

      return `${url.pathname}${url.search}${url.hash}`;
    } catch (error) {
      return '/pages/skin1004?inura_return=1';
    }
  }

  function ensureReturnStyle() {
    if (
      document.querySelector(
        '[data-inura-campaign-return-style]'
      )
    ) {
      return;
    }

    const style = document.createElement('style');

    style.setAttribute(
      'data-inura-campaign-return-style',
      ''
    );

    style.textContent = `
      .inura-campaign-return {
        box-sizing: border-box;
        width: 100%;
        padding-top: 12px;
        padding-bottom: 2px;
      }

      .inura-campaign-return__link {
        display: inline-flex;
        align-items: center;
        gap: .45rem;
        color: inherit;
        font-size: 12px;
        line-height: 1.3;
        letter-spacing: .075em;
        text-decoration: none;
        text-transform: uppercase;
        opacity: .62;
        transition: opacity .2s ease;
      }

      .inura-campaign-return__link:hover,
      .inura-campaign-return__link:focus-visible {
        opacity: 1;
        text-decoration: underline;
        text-underline-offset: .25em;
      }

      @media screen and (max-width: 749px) {
        .inura-campaign-return {
          padding-top: 9px;
          padding-bottom: 0;
        }

        .inura-campaign-return__link {
          font-size: 11px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function mountReturnLink() {
    const existing =
      document.querySelector(
        '[data-inura-campaign-return]'
      );

    if (!campaignIsActive()) {
      if (existing) existing.remove();
      return;
    }

    if (existing) {
      const existingLink =
        existing.querySelector('a');

      if (existingLink) {
        existingLink.href = buildReturnUrl();
      }

      return;
    }

    const main =
      document.querySelector('#MainContent') ||
      document.querySelector('main');

    if (!main) return;

    ensureReturnStyle();

    const wrapper = document.createElement('div');

    wrapper.className =
      'inura-campaign-return page-width';

    wrapper.setAttribute(
      'data-inura-campaign-return',
      ''
    );

    const link = document.createElement('a');

    link.className =
      'inura-campaign-return__link';

    link.href = buildReturnUrl();

    link.textContent =
      '← Retour à la sélection SKIN1004';

    wrapper.appendChild(link);
    main.insertBefore(wrapper, main.firstChild);
  }

  function scheduleMount() {
    if (mountQueued) return;

    mountQueued = true;

    window.requestAnimationFrame(() => {
      mountQueued = false;
      mountReturnLink();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleMount,
      { once: true }
    );
  } else {
    scheduleMount();
  }

  window.addEventListener(
    'pageshow',
    scheduleMount
  );

  window.addEventListener(
    'popstate',
    scheduleMount
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleMount
  );

  /*
   * Pitch peut naviguer depuis la LP SKIN1004
   * vers une fiche produit sans recharger les scripts.
   * Cet observateur n'existe désormais que dans ce parcours.
   */
  const routeObserver =
    new MutationObserver(scheduleMount);

  routeObserver.observe(
    document.body || document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );
})();